module.exports = __webpack_public_path__ + "static/Dzemo_laptop-783f6c3292f693bd687b274bc1f80bf3.jpeg";